import React, { useEffect, useMemo } from 'react'
import { FullPage, LocationsMap, TextHeader, BackButton } from '@wallyhealth/web-core'
import { sort, descend, prop } from 'ramda'
import styles from './index.module.css'
import intelService from 'services/intelService'

const sortedLocations = sort(descend(prop('id')))

const PAGE_NAME = 'JoinStudioPage'

const JoinStudioPageV2 = ({ onLocationPicked, onBack, geos = [] }) => {
  useEffect(() => {
    intelService.recordView({ viewName: PAGE_NAME })
  }, [])

  const handleLocationSelect = (location) => {
    intelService.recordClick({
      clickName: 'LocationPick',
      viewName: PAGE_NAME,
      properties: {
        locationId: location.id,
        locationName: location.name
      }
    })

    onLocationPicked(location.id)
  }

  const filteredGeos = useMemo(() => {
    return geos.map(geo => ({
      ...geo,
      locations: sortedLocations(geo.locations || [])
        .filter(loc => loc.isActive)
        .filter(loc => loc.isJoinFlowVisible)
    })).filter(geo => geo.locations.length > 0)
  }, [geos])

  return (
    <FullPage>
      <div className={styles.container}>
        <BackButton
          onClick={onBack}
          className={styles.back}
        />
        <TextHeader
          className={styles.header}
          title="Choose your home studio."
          subtitle="Don't worry, you can still visit any of our other studios."
        />

        {filteredGeos.length > 0 && (
          <LocationsMap
            geos={filteredGeos}
            onSelect={handleLocationSelect}
            actionLabel="Select"
            className={styles.map}
          />
        )}
      </div>
    </FullPage>
  )
}

export default JoinStudioPageV2
